import { Module, GetterTree, MutationTree } from 'vuex';
import Vue from 'vue';
import { RootState } from '@/store';
import { markModule } from './StoreTypes';

export interface LoaderState {
    loadingItems: { [loadingSource: string]: number };
}

export const loaderModule = markModule({
    namespaced: true,
    state: {
        loadingItems: {}
    } as LoaderState,
    mutations: {
        startLoading(state, loadingSource: string) {
            if (!state.loadingItems[loadingSource]) {
                Vue.set(state.loadingItems, loadingSource, 1);
            }
            else {
                const count = state.loadingItems[loadingSource];
                Vue.set(state.loadingItems, loadingSource, count + 1);
            }
        },
        finishLoading(state, loadingSource: string) {
            if (state.loadingItems[loadingSource] >= 1) {
                const count = state.loadingItems[loadingSource];
                Vue.set(state.loadingItems, loadingSource, count - 1);
            }
            else {
                Vue.set(state.loadingItems, loadingSource, 0);
            }
        }
    },
    getters: {
        loading: state => {
            const keys = Object.keys(state.loadingItems);
            return keys.length > 0 && keys.some(key => state.loadingItems[key] >= 1);
        },
    },
    actions: {
        startLoading({ commit }, loadingSource: string) {
            commit('startLoading', loadingSource);
        },
        finishLoading({ commit }, loadingSource: string) {
            commit('finishLoading', loadingSource);
        }
    },
    modules: {}
}, {} as RootState);
